<template>
  <ul v-if="isLabelsCreated" class="footer-errors mb-0">
    <li>Labels: {{ getLabelsSuccessCreatedCount }} / {{ assignment.itemsCount }}</li>
    <li>
      <div class="errors-slots">
        Errors:
        <mdicon name="Square" class="mx-2" />
        {{ labelsNotCreatedCount }}
        {{ pluralize('slot', labelsNotCreatedCount) }}
      </div>
    </li>
    <li>
      <div class="errors-type">
        <p>View type</p>
        <div class="switch-error">
          All
          <ToggleBtn v-model="isErrorsOnly" value="" />
          Errors only
        </div>
      </div>
    </li>
  </ul>
</template>

<script lang="ts">
import type { Assignment } from '@/types/Models/Assignment'
import { defineComponent, computed, watch, type ComputedRef } from 'vue'
import { LABELS_RELEASED } from '@/const/AssignmentStatuses'
import { pluralize } from '@/services/Helpers'
import { useAssignmentSummaryStore } from '@/store/assignmentSummary'
import { useItemStore } from '@/store/item'
import ToggleBtn from '@/views/Components/Elements/Buttons/ToggleBtn.vue'

export default defineComponent({
  name: 'LabelsCreatedErrors',
  components: { ToggleBtn },
  setup() {
    const assignmentSummaryStore = useAssignmentSummaryStore()
    const itemStore = useItemStore()

    const assignment: ComputedRef<Assignment> = computed(() => assignmentSummaryStore.assignment as Assignment)
    const status: ComputedRef<string> = computed(() => assignmentSummaryStore.assignmentStatus)
    const labelsNotCreatedCount: ComputedRef<number> = computed(() => assignmentSummaryStore.getLabelsNotCreatedCount)
    const getLabelsSuccessCreatedCount: ComputedRef<number> = computed(
      () => assignmentSummaryStore.getLabelsSuccessCreatedCount,
    )
    const isLabelsCreated: ComputedRef<boolean> = computed(() => status.value === LABELS_RELEASED)

    const isErrorsOnly = computed({
      get: () => itemStore.labelsErrorsOnly,
      set: (errorsOnly: boolean) => {
        itemStore.setLabelsErrorsOnly(errorsOnly)
      },
    })

    watch(labelsNotCreatedCount, (newVal) => {
      if (newVal === 0 && itemStore.labelsErrorsOnly) {
        itemStore.setLabelsErrorsOnly(false)
      }
    })

    return {
      assignment,
      isErrorsOnly,
      isLabelsCreated,
      labelsNotCreatedCount,
      getLabelsSuccessCreatedCount,
      pluralize,
    }
  },
})
</script>
